module.exports = __webpack_public_path__ + "static/media/ZSCE_MP.3699c982.pdf";